<template>
  <v-app-bar elevation="2" color="primary" height="55">
    <v-app-bar-nav-icon
      v-if="showMenuIcon"
      class="hidden-md-and-up"
      variant="text"
      @click="toggleMobileMenu"
    ></v-app-bar-nav-icon>
    <v-img
      src="/assets/pwc-logo.svg"
      max-width="45px"
      class="ml-5 mt-2 app-header text-center"
      @click="routeToHome"
    />
    <v-toolbar-title
      class="mt-0 ml-3 app-header app-header-text"
      @click="routeToHome"
    >
      Transparency Chain
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <UserMenu />
  </v-app-bar>
</template>

<script setup lang="ts">
import { RouterPath } from "@/models/enum/routerPath";
import router from "@/router";
import UserMenu from "@/components/header/UserMenu.vue";

const props = defineProps<{
  showMenuIcon: boolean;
  showMobileMenu: boolean;
}>();

const emit = defineEmits<{
  (e: "toggleMobileMenu", showMobileMenu: boolean): void;
}>();

function toggleMobileMenu() {
  emit("toggleMobileMenu", !props.showMobileMenu);
}

function routeToHome(): void {
  router.push(RouterPath.Home);
}
</script>

<style scoped lang="scss">
.app-header {
  :hover {
    cursor: pointer;
  }
}

.app-header-text {
  color: var(--medium-grey);
  margin-left: 0.5rem;
  font-size: 16px;
}
</style>
